import React from 'react';
import { useForm, Controller } from 'react-hook-form';

import { Icon, IconClose } from '@flixbus/honeycomb-icons-react';
import { Grid, GridCol, Tag } from '@flixbus/honeycomb-react';

import CrewMemberTextSearch from 'common/CrewMemberTextSearch';
import LocationSearch from 'common/LocationSearch';
import MobilityPartnerField from 'pages/CrewManagement/components/MobilityParnerField/MobilityPartnerField';
import GroupSearch from 'pages/CrewTimeline/components/TimeLineFilter/Group';

import styles from './management.module.css';

const EMPTY_VALUE = {
	search: '',
	homeLocation: '',
	mobilePartner: '',
	group: '',
};

const ManagementFilter = ({
	onFilterSubmitted,
	isIncompleteProfilesSet,
	cancelIncompleteProfilesMode,
	problematicCount,
}) => {
	const { control, resetField, getValues, handleSubmit, setValue } = useForm({
		mode: 'onChange',
		defaultValues: EMPTY_VALUE,
	});

	const onSubmit = (data) => {
		onFilterSubmitted(data);
	};

	const submitOnChange = () => {
		const data = getValues();
		onFilterSubmitted(data);
	};

	const handleResetSingleField = (fieldname) => {
		resetField(fieldname);
		submitOnChange();
	};

	return (
		<form className={styles.wrapper} autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
			<Grid>
				<GridCol size={3}>
					<Controller
						name="search"
						control={control}
						render={({ field, fieldState }) => {
							const { isDirty } = fieldState;
							return (
								<CrewMemberTextSearch
									fieldControl={field}
									submitOnChange={submitOnChange}
									onReset={() => handleResetSingleField(field.name)}
									isDirty={isDirty}
									ref={null}
									id="search"
									label="Search"
									placeholder="Name or employee number"
								/>
							);
						}}
					/>
				</GridCol>
				<GridCol size={2}>
					<Controller
						name="homeLocation"
						control={control}
						render={({ field }) => {
							return (
								<LocationSearch
									onReset={() => handleResetSingleField(field.name)}
									fieldControl={field}
									resubmit={submitOnChange}
									setValue={setValue}
								/>
							);
						}}
					/>
				</GridCol>
				<GridCol size={2}>
					<Controller
						name="mobilePartner"
						control={control}
						render={({ field }) => {
							return (
								<MobilityPartnerField
									fieldControl={field}
									submitOnChange={() => submitOnChange()}
								/>
							);
						}}
					/>
				</GridCol>
				<GridCol>
					<Controller
						name="group"
						control={control}
						render={({ field }) => (
							<GroupSearch fieldControl={field} submitOnChange={() => submitOnChange()} />
						)}
					/>
				</GridCol>
				{isIncompleteProfilesSet && problematicCount > 0 && (
					<GridCol>
						<div className={styles.incomplete}>
							<span className={styles.head}>Filtered by:</span>
							<Tag elem="div" display="outlined" extraClasses={styles.textBold}>
								Incomplete profiles ({problematicCount})
								<Icon
									onClick={cancelIncompleteProfilesMode}
									InlineIcon={IconClose}
									extraClasses={styles.icon}
								/>
							</Tag>
						</div>
					</GridCol>
				)}
			</Grid>
		</form>
	);
};

export default ManagementFilter;
